import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';

import {isNotNil} from 'ramda';

import {
  CreateBatchApiArg,
  CreateBatchApiResponse,
  GetBatchApiArg,
  GetBatchApiResponse,
  ListBatchVehiclesApiArg,
  ListBatchVehiclesApiResponse,
  ListBatchesApiArg,
  ListBatchesApiResponse,
  UpdateBatchVehicleApiArg,
  UpdateBatchVehicleApiResponse,
} from '../types/api/api';

export const importApi = createApi({
  reducerPath: 'import',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.IMPORT_PRICE_REPORT_API_URL,
  }),
  tagTypes: ['BatchVehicles'],
  endpoints: (build) => ({
    listBatches: build.query<ListBatchesApiResponse, ListBatchesApiArg>({
      query: () => ({url: `/api/batches`}),
    }),
    createBatch: build.mutation<CreateBatchApiResponse, CreateBatchApiArg>({
      query: (queryArg) => {
        const formData = new FormData();
        formData.append('file', queryArg.body.file);
        formData.append('market', queryArg.body.market);
        if (isNotNil(queryArg.body.user_id)) {
          formData.append('user_id', queryArg.body.user_id);
        }
        return {
          url: `/api/batches`,
          method: 'POST',
          body: formData,
          params: {vin_decoding_provider: queryArg.vinDecodingProvider},
        };
      },
    }),
    getBatch: build.query<GetBatchApiResponse, GetBatchApiArg>({
      query: (queryArg) => ({url: `/api/batches/${queryArg.batchId}`}),
    }),
    listBatchVehicles: build.query<ListBatchVehiclesApiResponse, ListBatchVehiclesApiArg>({
      query: (queryArg) => ({
        url: `/api/batches/${queryArg.batchId}/vehicles`,
        params: {page: queryArg.page, limit: queryArg.limit},
      }),
      providesTags: (_result, _error, queryArg) => [{type: 'BatchVehicles', id: queryArg.batchId}],
    }),
    updateBatchVehicle: build.mutation<UpdateBatchVehicleApiResponse, UpdateBatchVehicleApiArg>({
      query: (queryArg) => ({
        url: `/api/batches/${queryArg.batchId}/vehicles/${queryArg.vehicleId}`,
        method: 'PUT',
        body: queryArg.updateVehicleRequest,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'BatchVehicles', id: queryArg.batchId},
      ],
    }),
  }),
});

export const {
  useListBatchesQuery,
  useCreateBatchMutation,
  useGetBatchQuery,
  useListBatchVehiclesQuery,
  useUpdateBatchVehicleMutation,
} = importApi;
